import { useTranslation } from 'react-i18next';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const deleteEvent = async (eventId: string) => {
  return await request({
    url: `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}/delete`,
    method: RequestMethod.DELETE,
  });
};

export const useDeleteEvent = ({ eventId }: { eventId: string }) => {
  const { t } = useTranslation();
  const toast = useToast();
  const queryClient = useQueryClient();
  return useGenericMutation<{}, RequestError, { eventId: string }>(
    ['delete-event', eventId],
    async (params) => deleteEvent(params.eventId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['get-event-list-draft']);
        toast.push({
          title: t('eventList:deleteEventSuccessNotificationTitle'),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
